import React from "react";
import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

// Visible FAQ block (content stays in the DOM for crawlers even when collapsed).
// Pair it with a schema.org FAQPage JSON-LD on the page for rich snippets.
export const FaqSection = ({ items = [], title = "Questions fréquentes" }) => {
  if (!items.length) return null;
  return (
    <section className="mt-10" data-testid="faq-section">
      <div className="mb-3 flex items-center gap-2">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <HelpCircle className="h-5 w-5" />
        </span>
        <h2 className="font-display text-xl font-bold text-foreground">{title}</h2>
      </div>
      <Accordion type="single" collapsible className="w-full">
        {items.map((f, i) => (
          <AccordionItem key={f.q || `faq-${i}`} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left text-[15px] font-semibold text-foreground">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[15px] leading-relaxed text-muted-foreground">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
